// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Utils = require("../../utils/Utils.bs.js");
let FormV5 = require("../../uikit/reason/atoms/Form/FormV5.bs.js");
let Scalars = require("../../scalars/Scalars.bs.js");
let Belt_Array = require("@rescript/runtime/lib/js/Belt_Array.js");
let View__Jsx3 = require("../../uikit/reason/helpers/View__Jsx3.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Form__Helpers = require("../../reason/common/Form/Form__Helpers.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let AutocompleteV5 = require("../autocomplete/AutocompleteV5.bs.js");
let Form__Validators = require("../../reason/common/Form/Form__Validators.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelayReact = require("rescript-relay/src/RescriptRelayReact.bs.js");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let SharingContactsInputRelayQuery_graphql = require("../../__generated__/SharingContactsInputRelayQuery_graphql.bs.js");

function contactToString(x) {
  if (x.TAG !== "Contact") {
    return x.email;
  }
  let x$1 = Form__Helpers.opt_of_string(Utils.List.join(" ", undefined, Utils.List.stripNones({
    hd: x.firstName,
    tl: {
      hd: x.lastName,
      tl: /* [] */0
    }
  })));
  return Stdlib_Option.getOr(Stdlib_Option.isNone(x$1) ? x.email : x$1, " ");
}

function getOptionValue(x) {
  if (x.TAG === "Contact") {
    return x.id;
  } else {
    return x.email;
  }
}

function getOptionLabel(x) {
  if (x.TAG === "Contact") {
    return Stdlib_Option.getOr(x.firstName, " ");
  } else {
    return x.email;
  }
}

function toString(x) {
  if (x.TAG !== "Contact") {
    return x.email;
  }
  let x$1 = Form__Helpers.opt_of_string(Utils.List.join(" ", undefined, Utils.List.stripNones({
    hd: x.firstName,
    tl: {
      hd: x.lastName,
      tl: /* [] */0
    }
  })));
  return Stdlib_Option.getOr(Stdlib_Option.isNone(x$1) ? x.email : x$1, " ");
}

let ContactOption = {
  getOptionValue: getOptionValue,
  getOptionLabel: getOptionLabel,
  toString: toString
};

let convertVariables = SharingContactsInputRelayQuery_graphql.Internal.convertVariables;

let convertResponse = SharingContactsInputRelayQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = SharingContactsInputRelayQuery_graphql.Internal.convertWrapRawResponse;

let use = RescriptRelay_Query.useQuery(convertVariables, SharingContactsInputRelayQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, SharingContactsInputRelayQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(SharingContactsInputRelayQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch_(SharingContactsInputRelayQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(SharingContactsInputRelayQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(SharingContactsInputRelayQuery_graphql.node, convertVariables);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function SharingContactsInputRelay(props) {
  let __placeholder = props.placeholder;
  let validationResult = props.validationResult;
  let onChange = props.onChange;
  let value = props.value;
  let placeholder = __placeholder !== undefined ? __placeholder : "Enter your client's email address";
  let environment = RescriptRelayReact.useEnvironmentFromContext();
  let isValidNewOption = str => Form__Validators.boolOfValidation(Form__Validators.isEmail(str.trim()));
  let tmp;
  tmp = validationResult !== undefined ? (
      validationResult.TAG === "Ok" ? "Success" : "Failure"
    ) : "Neutral";
  let tmp$1;
  tmp$1 = validationResult !== undefined && validationResult.TAG !== "Ok" ? JsxRuntime.jsx(View__Jsx3.make, {
      children: JsxRuntime.jsx(FormV5.$$Error.make, {
        children: validationResult._0
      })
    }) : null;
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(AutocompleteV5.AsyncCreatableSelect.Multi.make, {
        id: props.id,
        getOptionLabel: getOptionLabel,
        getOptionValue: getOptionValue,
        getNewOptionData: str => ({
          TAG: "Email",
          email: str.trim()
        }),
        defaultOptions: true,
        loadOptions: async str => {
          let match = await fetchPromised(environment, {
            query: str
          }, undefined, undefined);
          let match$1 = match.sharingContactsV5;
          if (match$1 === undefined) {
            return [];
          }
          let sharingContacts = match$1.sharingContacts;
          if (sharingContacts !== undefined) {
            return Stdlib_Array.filterMap(sharingContacts, c => {
              switch (c.__typename) {
                case "SharingContactClientContactV5" :
                  return {
                    TAG: "Contact",
                    firstName: c.firstName,
                    lastName: c.lastName,
                    email: Stdlib_Option.map(c.email, e => Scalars.EmailAddress.toString(e)),
                    id: c.databaseId
                  };
                case "SharingContactFreshContactV5" :
                  return {
                    TAG: "Contact",
                    email: Stdlib_Option.map(c.email, e => Scalars.EmailAddress.toString(e)),
                    id: c.databaseId
                  };
                case "__unselected" :
                  return;
              }
            });
          } else {
            return [];
          }
        },
        onBlur: props.onBlur,
        onChange: onChange,
        noOptionsMessage: param => {},
        placeholder: placeholder,
        status: tmp,
        value: Stdlib_Option.getOr(value, []),
        onPaste: e => {
          let text = e.clipboardData.getData("text");
          let isDuplicate = () => Stdlib_Option.getOr(value, []).some(x => {
            if (x.TAG === "Contact") {
              return false;
            } else {
              return x.email === text;
            }
          });
          if (Form__Validators.boolOfValidation(Form__Validators.isEmail(text.trim())) && !isDuplicate()) {
            e.preventDefault();
            return onChange(Belt_Array.concatMany([
              Stdlib_Option.getOr(value, []),
              [{
                  TAG: "Email",
                  email: text.trim()
                }]
            ]));
          }
        },
        isValidNewOption: isValidNewOption,
        formatOptionLabel: (option, context) => {
          if (context.context === "menu") {
            if (option.TAG === "Contact") {
              return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                    children: (Stdlib_Option.getOr(option.firstName, "") + " " + Stdlib_Option.getOr(option.lastName, "")).trim()
                  }),
                  JsxRuntime.jsx("div", {
                    children: Stdlib_Option.getOr(option.email, "")
                  })
                ]
              });
            } else {
              return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                    children: "Send to:"
                  }),
                  JsxRuntime.jsx("div", {
                    children: option.email
                  })
                ]
              });
            }
          }
          if (option.TAG !== "Contact") {
            return JsxRuntime.jsx("div", {
              children: option.email
            });
          }
          let match = option.firstName;
          let match$1 = option.email;
          return JsxRuntime.jsx("div", {
            children: match !== undefined ? match : (
                match$1 !== undefined ? match$1 : "unknown contact"
              )
          });
        }
      }),
      tmp$1
    ]
  });
}

let make = SharingContactsInputRelay;

exports.contactToString = contactToString;
exports.ContactOption = ContactOption;
exports.Query = Query;
exports.make = make;
/* use Not a pure module */
